export const SERVICES_DATA = [
  {
    slug: "house-movers-melbourne",
    nav: "House Moving",
    title: "House Movers Melbourne",
    img: "/images/hero-branded.png",
    paragraphs: [
      "Moving to a new house, apartment or unit? Our house movers in Melbourne can help with loading, transportation and unloading while taking care of your furniture and belongings throughout the move.",
      "From smaller apartment moves to larger family homes, we'll help you plan the right moving solution for your property and requirements.",
    ],
  },
  {
    slug: "local-removalists-melbourne",
    nav: "Local Removalists",
    title: "Local Removalists Melbourne",
    img: "/images/boxes-branded.png",
    paragraphs: [
      "Moving within Melbourne? Our local removalists in Melbourne service suburbs across Greater Melbourne, helping households move safely and efficiently.",
      "Whether you're moving a few suburbs away or across the Melbourne metro area, we can help with your local move.",
    ],
  },
  {
    slug: "apartment-unit-removalists",
    nav: "Apartment & Unit Moving",
    title: "Apartment & Unit Removalists",
    img: "/images/truck-small.png",
    paragraphs: [
      "Apartment moves can come with additional challenges such as stairs, lifts, limited parking and restricted access. Our moving team can help you plan around your property's access requirements and safely move your furniture and belongings to your new home.",
      "Moving apartments? Tell us about your property when requesting your quote.",
    ],
  },
  {
    slug: "furniture-removal-melbourne",
    nav: "Furniture Removal",
    title: "Furniture Removal Melbourne",
    img: "/images/boxes-branded.png",
    paragraphs: [
      "Need to move a sofa, bed, table, appliances or other large items? Our furniture removal service is suitable for individual items, smaller moving jobs and furniture transfers.",
      "Tell us what needs to be moved, where it's being collected and where it needs to go.",
    ],
  },
  {
    slug: "office-moving-relocation",
    nav: "Office Moving & Relocation",
    title: "Office Moving & Relocation",
    img: "/images/truck-large.png",
    paragraphs: [
      "Moving your business or office? MoversNearby provides professional office moving services in Melbourne to help businesses relocate with less disruption.",
      "We can assist with moving office furniture, equipment and other items as part of your relocation.",
    ],
  },
  {
    slug: "interstate-removalists",
    nav: "Interstate Removalists",
    title: "Interstate Removalists",
    img: "/images/truck-medium.png",
    paragraphs: [
      "Moving interstate from Melbourne? MoversNearby provides interstate moving services from Melbourne to destinations across Australia — including Sydney, Brisbane, Adelaide and beyond.",
      "For interstate moves, provide your pickup location, destination and preferred moving date so we can assess your requirements and plan the right moving solution.",
    ],
  },
  {
    slug: "packing-services",
    nav: "Packing Services",
    title: "Packing Services Melbourne",
    img: "/images/boxes-branded.png",
    paragraphs: [
      "Don't want to pack? Our team can professionally pack your home or office using quality boxes, wrapping and protective materials — so your belongings travel safely.",
      "From a few fragile items to a full household pack, tell us what you need when requesting your quote and we'll include it in your moving plan.",
    ],
  },
];
